import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export default function addTableRowBelow(editor) {
  var cell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : editor.value.focusBlock;
  var tableId = editor.getCurrentTableId();

  var _editor$getCellCoords = editor.getCellCoords(cell),
      _editor$getCellCoords2 = _slicedToArray(_editor$getCellCoords, 1),
      row = _editor$getCellCoords2[0];

  return editor.addTableRow(tableId, row + 1);
}